import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGet } from "hooks/fetch/useFetchGet";

export function useGetSiteById(siteId, page = 1, pageSize = 10000) {
  const url = useMemo(
    () =>
      `sites/${siteId}` +
      makeQueryString({
        page,
        size: pageSize
      }),
    [siteId, page, pageSize]
  );
  const { loading, error, response } = useFetchGet(url);

  return {
    loading,
    error,
    site: response
  };
}
